import { css } from 'styled-components';

const styles = css`
  display: flex;
  align-items: center;
  padding: 7px 18px;
  border-top: 1px solid #d8d8d8;
  background: #fff;
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding: 12px 24px;
  }
  .cta-link {
    font-weight: 700;
    text-decoration-line: underline;
    margin-right: 3px;
    letter-spacing: -0.1px;
    cursor: pointer;
    text-transform: capitalize;
  }
  .bag-simplified-text {
    font-weight: 400;
    letter-spacing: -0.1px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      letter-spacing: normal;
    }
  }
  .simplified-mpr-plcc-theme {
    color: #ff8e15;
    font-weight: 800;
  }
`;

export default styles;
